import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import type {
  QueryBySkillsRequest,
  QueryBySkillsResponse,
} from '@coursera/grpc-types-skills/coursera/proto/skills/scores/v1/skill_scores_api';

export type PropsFromCaller = {
  skillId: string;
  userId?: number;
};

export type PropsFromSkillScoreGraphql = {
  loadingScore?: boolean;
  skillScore?: number;
};

export const SkillScoreQuery = gql`
  query SkillScoreQuery($input: QueryBySkillsRequest!) {
    QueryBySkills(input: $input)
      @rest(type: "QueryBySkillsResponse", path: "grpc/skills/scores/v1/SkillScoresAPI/QueryBySkills", method: "POST") {
      skillScores
    }
  }
`;

const withSkillScore = graphql<
  PropsFromCaller,
  { QueryBySkills: QueryBySkillsResponse },
  { input: QueryBySkillsRequest },
  PropsFromSkillScoreGraphql
>(SkillScoreQuery, {
  skip: ({ userId }) => !userId,
  options: ({ skillId, userId }) => ({
    variables: {
      input: {
        userId,
        skillIds: [skillId],
        pageSize: 50,
        courseItemIds: [],
        pageToken: '',
      },
    },
  }),
  props: ({ data }) => ({
    loadingScore: data?.loading ?? false,
    skillScore: data?.QueryBySkills?.skillScores?.[0]?.scaledSkillScore,
  }),
});

export default withSkillScore;
